meedy.factory('meedy.dictionaryService', ['$q', '$translate', 'meedy.baseService', 'meedy.objectHelper', 'meedyConfig',
    function ($q, $translate, baseService, objectHelper, config) {

        function DictionaryService() {

            this.getStates = function () {
                var d = $q.defer();

                baseService.get(config.API_URL + '/dictionaries/getStates').then(
                    function (successResponse) {
                        var dataPage = objectHelper.translateObject(successResponse, DataPageVO);
                        dataPage.data = objectHelper.translateArray(dataPage.data, StateMeedyVO);

                        d.resolve(dataPage);
                    },
                    function (errorResponse) {
                        d.reject(errorResponse);
                    }
                );

                return d.promise;
            };

            this.getSpecializations = function () {
                var d = $q.defer();

                baseService.get(config.API_URL + '/dictionaries/getSpecializations').then(
                    function (successResponse) {
                        var dataPage = objectHelper.translateObject(successResponse, DataPageVO);
                        dataPage.data = objectHelper.translateArray(dataPage.data, SpecializationMeedyVO);

                        d.resolve(dataPage);
                    },
                    function (errorResponse) {
                        d.reject(errorResponse);
                    }
                );

                return d.promise;
            };

            this.getAcademicTitles = function () {
                var d = $q.defer();

                baseService.get(config.API_URL + '/dictionaries/getAcademicTitles').then(
                    function (successResponse) {
                        var dataPage = objectHelper.translateObject(successResponse, DataPageVO);
                        dataPage.data = objectHelper.translateArray(dataPage.data, AcademicTitleMeedyVO);

                        d.resolve(dataPage);
                    },
                    function (errorResponse) {
                        d.reject(errorResponse);
                    }
                );

                return d.promise;
            };

        }

        return new DictionaryService();
    }
]);
